import React from 'react';
import type { CornerLineProps } from '@components/atoms/corner-line-window/types';
import { CameraVariantLineEnum } from '@models/enums';
import cn from 'classnames';
import { styled } from 'styled-components';

import { Container, Line } from './styles';

const Atom: React.FC<CornerLineProps> = ({ success, loading, className, variant }) => {
    const listLine = Array.from(Array(4).keys());

    return (
        <Container
            className={cn(className, {
                selfie: variant === CameraVariantLineEnum.SELFIE,
                loading,
                success,
                error: success === false,
            })}
        >
            {(variant === CameraVariantLineEnum.DOCS || CameraVariantLineEnum.POA) && (
                <React.Fragment>
                    {listLine?.map((e) => (
                        <Line
                            key={e}
                            className={cn('box-photos-window-line', {
                                loading,
                                success,
                                error: success === false,
                            })}
                        >
                            <svg
                                width='56'
                                height='53'
                                viewBox='0 0 56 53'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M55.5643 51.9992C55.5643 52.5514 55.1166 52.9992 54.5643 52.9992C54.012 52.9992 53.5643 52.5515 53.5643 51.9992L55.5643 51.9992ZM1.8582 2.12218C1.30916 2.18195 0.81563 1.78531 0.755872 1.23626C0.696111 0.687219 1.09275 0.193687 1.64179 0.133931L1.8582 2.12218ZM54.5638 7.11272L55.5638 7.11271L54.5638 7.11272ZM48.5942 1.11406L48.5921 2.11406L48.5942 1.11406ZM53.5643 51.9992L53.5638 7.11274L55.5638 7.11271L55.5643 51.9992L53.5643 51.9992ZM48.5921 2.11406C41.7775 2.09989 30.2941 2.07868 20.401 2.07337C15.4544 2.07072 10.9061 2.07203 7.53826 2.08019C5.85407 2.08427 4.46653 2.09005 3.47239 2.09789C2.975 2.10181 2.5784 2.10622 2.29325 2.11115C1.97791 2.1166 1.85751 2.12226 1.8582 2.12218L1.64179 0.133931C1.82082 0.114445 2.50291 0.105469 3.45663 0.0979535C4.45631 0.0900718 5.84819 0.0842777 7.53341 0.0801939C10.9043 0.0720342 15.4549 0.0707179 20.4021 0.0733735C30.2968 0.078686 41.7815 0.099893 48.5962 0.114058L48.5921 2.11406ZM53.5638 7.11274C53.5638 4.35254 51.345 2.11978 48.5921 2.11406L48.5962 0.114058C52.4594 0.122088 55.5638 3.25683 55.5638 7.11271L53.5638 7.11274Z'
                                    fill='currentColor'
                                />
                            </svg>
                        </Line>
                    ))}
                </React.Fragment>
            )}
        </Container>
    );
};

export const CornerLine = styled(Atom)({});

